import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import BinaryGrid from "@/components/subject/NineGridMirrorInference/NineGridMirrorBinaryGrid.vue";
export default {
  name: "NineGridMirrorInferenceRender",
  components: {
    BinaryGrid
  },
  props: {
    review: {
      type: Object,
      default: () => null
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      viewedCount: 0,
      showingExample: false,
      currentExample: null,
      timer: null,
      answerGrid: this.emptyGrid(),
      passSelected: false
    };
  },
  computed: {
    cells() {
      return Array.from({
        length: 9
      }, (_, index) => index);
    },
    reviewGrid() {
      return this.parseAnswer(this.review?.answer).grid;
    },
    reviewPass() {
      return this.parseAnswer(this.review?.answer).pass;
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.init();
      }
    },
    review: {
      deep: true,
      handler() {
        this.init();
      }
    },
    reviewMode() {
      this.init();
    }
  },
  methods: {
    emptyGrid() {
      return [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
    },
    init() {
      this.clearTimer();
      this.currentExample = null;
      this.showingExample = false;
      this.viewedCount = this.reviewMode ? 4 : 0;
      const parsed = this.reviewMode ? this.parseAnswer(this.review?.answer) : {
        grid: this.emptyGrid(),
        pass: false
      };
      this.answerGrid = parsed.grid;
      this.passSelected = parsed.pass;
      this.emitAnswer();
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    playNextExample() {
      if (this.reviewMode || this.showingExample || this.viewedCount >= 4) {
        return;
      }
      const example = this.data?.examples?.[this.viewedCount];
      if (!example) {
        return;
      }
      this.viewedCount += 1;
      this.currentExample = example;
      this.showingExample = true;
      this.timer = setTimeout(() => {
        this.currentExample = null;
        this.showingExample = false;
        this.emitAnswer();
      }, 2000);
    },
    toggleCell(cell) {
      if (this.reviewMode || this.viewedCount < 4) {
        return;
      }
      const row = Math.floor(cell / 3);
      const col = cell % 3;
      this.answerGrid[row][col] = this.answerGrid[row][col] === 1 ? 0 : 1;
      this.answerGrid = this.answerGrid.map(rowCells => rowCells.slice());
      this.emitAnswer();
    },
    togglePass() {
      if (this.reviewMode || this.viewedCount < 4) {
        return;
      }
      this.passSelected = !this.passSelected;
      this.emitAnswer();
    },
    clearAnswer() {
      if (this.reviewMode) {
        return;
      }
      this.answerGrid = this.emptyGrid();
      this.passSelected = false;
      this.emitAnswer();
    },
    hasAnyBlack(grid) {
      return grid.some(row => row.some(cell => cell === 1));
    },
    emitAnswer() {
      if (this.reviewMode) {
        return;
      }
      if (this.viewedCount < 4 || this.showingExample || !this.hasAnyBlack(this.answerGrid)) {
        this.$emit('answer', null);
        return;
      }
      this.$emit('answer', this.encodeAnswer(this.answerGrid, this.passSelected));
    },
    encodeAnswer(grid, pass) {
      const cells = [];
      grid.forEach((row, rowIndex) => {
        row.forEach((cell, colIndex) => {
          if (cell === 1) {
            cells.push(`${rowIndex},${colIndex}`);
          }
        });
      });
      return `cells=${cells.join('|')};pass=${pass ? 'Y' : 'N'}`;
    },
    parseAnswer(answer) {
      const parsed = {
        grid: this.emptyGrid(),
        pass: false
      };
      if (!answer) {
        return parsed;
      }
      answer.split(';').forEach(part => {
        const trimmed = part.trim();
        if (trimmed.startsWith('cells=')) {
          const cells = trimmed.slice(6).trim();
          if (!cells) {
            return;
          }
          cells.split('|').forEach(cell => {
            const pair = cell.split(',');
            if (pair.length !== 2) {
              return;
            }
            const row = Number(pair[0]);
            const col = Number(pair[1]);
            if (row >= 0 && row < 3 && col >= 0 && col < 3) {
              parsed.grid[row][col] = 1;
            }
          });
        }
        if (trimmed.startsWith('pass=')) {
          parsed.pass = trimmed.slice(5).trim().toUpperCase() === 'Y';
        }
      });
      parsed.grid = parsed.grid.map(row => row.slice());
      return parsed;
    },
    operateText(operate) {
      const mapping = {
        ROTATE_CLOCKWISE_90: '顺时针旋转90度',
        ROTATE_COUNTERCLOCKWISE_90: '逆时针旋转90度',
        FLIP_VERTICAL: '上下翻转',
        FLIP_HORIZONTAL: '左右翻转'
      };
      return mapping[operate] || '未知操作';
    }
  },
  mounted() {
    this.init();
  },
  beforeUnmount() {
    this.clearTimer();
  }
};